import { API_CACHE_KEYS } from "api/cacheKeys";
import { useCustomQuery } from "api/useCustomQuery";
import { JANZU_URL } from "config/config";
import { User } from "types/users";

import { BaseQueryOptions } from "../types";

// Hook for fetching current user data
export const useCurrentUser = (options: BaseQueryOptions<User> = {}) => useCustomQuery<User>(
  API_CACHE_KEYS.user.me(),
  `${JANZU_URL}device-api/me`,
  {
    retry: 2,
    enabled: true,
    refetchOnMount: true,
    ...options,
  }
);
